import { useState } from "react";
import loginCardLogo from "../../assets/Logo_Full_Transparent.png";
import loginBackgroundWebp from "../../assets/Background-opt.webp";
import { Card, Input, Btn, IconEye, IconEyeOff } from "../../components/ui";
import { apiUrl } from "../../utils/api";

const toLogin = () => {
  window.location.hash = "";
  window.location.reload();
};

export function ResetPassword({ token }: { token: string }) {
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [show, setShow] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [done, setDone] = useState(false);

  const submit = async () => {
    setError(null);
    if (password.length < 6) {
      setError("Das Passwort muss mindestens 6 Zeichen lang sein.");
      return;
    }
    if (password !== confirm) {
      setError("Die Passwörter stimmen nicht überein.");
      return;
    }
    setLoading(true);
    try {
      const resp = await fetch(apiUrl("/api/v1/auth/password"), {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ token, password, password_confirmation: confirm }),
      });
      const body = await resp.json().catch(() => ({}));
      if (!resp.ok) {
        throw new Error(Array.isArray(body.errors) ? body.errors.join(" ") : `HTTP ${resp.status}`);
      }
      setDone(true);
    } catch (e) {
      setError(e instanceof Error ? e.message : "Passwort konnte nicht gesetzt werden.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      className="fixed inset-0 flex items-center justify-center bg-cover bg-center bg-no-repeat"
      style={{ backgroundImage: `url(${loginBackgroundWebp})` }}
    >
      <Card className="p-6 w-full max-w-md grid gap-4">
        <img src={loginCardLogo} alt="Logo" className="w-full h-auto object-contain" />
        <div className="text-xl font-bold" style={{ fontFamily: '"Cinzel", serif' }}>Neues Passwort setzen</div>

        {done ? (
          <>
            <div className="text-sm text-[var(--green-dark)]">
              Ihr Passwort wurde aktualisiert. Sie können sich jetzt mit dem neuen Passwort anmelden.
            </div>
            <Btn onClick={toLogin}>Zur Anmeldung</Btn>
          </>
        ) : (
          <>
            <div className="text-sm text-slate-600">
              Bitte vergeben Sie ein neues Passwort. Es muss Groß- und Kleinbuchstaben, eine Zahl und ein Sonderzeichen enthalten.
            </div>
            <div className="relative">
              <Input
                type={show ? "text" : "password"}
                placeholder="Neues Passwort"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="pr-10"
              />
              <button
                type="button"
                className="absolute right-2 top-1/2 -translate-y-1/2 text-slate-500 hover:text-slate-700"
                onClick={() => setShow((v) => !v)}
                aria-label={show ? "Passwort verbergen" : "Passwort anzeigen"}
                title={show ? "Passwort verbergen" : "Passwort anzeigen"}
              >
                {show ? <IconEyeOff /> : <IconEye />}
              </button>
            </div>
            <Input
              type={show ? "text" : "password"}
              placeholder="Passwort bestätigen"
              value={confirm}
              onChange={(e) => setConfirm(e.target.value)}
            />
            {error && <div className="text-sm text-[var(--red)]">{error}</div>}
            <Btn onClick={submit} disabled={loading}>{loading ? "..." : "Passwort speichern"}</Btn>
            <button type="button" onClick={toLogin} className="text-sm text-slate-500 hover:text-slate-700 underline underline-offset-2">
              Zurück zur Anmeldung
            </button>
          </>
        )}
      </Card>
    </div>
  );
}
